






























import Vue from "vue";
import { EventLogger } from "@/js/EventLogger";

export default Vue.extend({
  name: "NoCameraPermission",
  props: {
    errorType: String
  },
  methods: {
    confirm() {
      EventLogger.singleton.sendCannotStartCameraConfirm();
      this.$emit("confirm");
    }
  }
});
